<template>
    <div>
        <welcome-component></welcome-component>
        <modules-component></modules-component>
        <platform-component></platform-component>
        <contacts-component></contacts-component>
        <gdpr-component></gdpr-component>
    </div>
</template>

<script>
    import WelcomeComponent from "./welcome-component";
    import ModulesComponent from "./modules-component/modules-component";
    import PlatformComponent from "./platform-component";
    import ContactsComponent from "./contacts-component";
    import GdprComponent from "./gdpr-component/gdpr-component";

    export default {
        name: "landing-component",
        components: {GdprComponent, ContactsComponent, PlatformComponent, ModulesComponent, WelcomeComponent},
        mounted() {
            const routeHash = this.$router.currentRoute.hash;
            if (routeHash !== '') {
                this.$scrollTo(routeHash)
            }
        }
    }
</script>

<style scoped>

</style>
